export default "__VITE_ASSET__CzUltsdC__";